export default {
  LANDING_COMPANY: {
    HEADER: {
      YOU_ARE_USER: 'For job seekers',
      DOWNLOAD_APP: 'Download app',
      ACCESS: 'Sign in',
      REGISTER: 'Sign up',
    },
    META: {
      TITLE: '<b>Hire top talent for&nbsp;your&nbsp;company on wokap!</b>',
      TEXT: 'The recruiting software that\'s&nbsp;revolutionizing how&nbsp;you&nbsp;hire.',
      TEXT2: 'Welcome to the future of hiring.',
      ACCESS: 'Sign in to wokap',
      TAGLINE: 'wokap is the recruiting software that is revolutionizing the way of hiring.',
    },
    COMPANIES: { TEXT: 'Companies achieving incredible&nbsp;results with wokap!' },
    CONTACT: {
      TITLE: 'Contact sales',
      TEXT: 'Company details',
      FORM: {
        NAME: 'Full name',
        COMPANY_NAME: 'Company name',
        PHONE: 'Phone number',
        EMAIL: 'Work email',
        SUBMIT: 'Send request',
        TERMS: 'By continuing, I agree to wokap\'s Terms of Service and Privacy Policy.',
        TOAST: {
          SUCCESS: 'Thanks for reaching out! We\'ll get back to you shortly.',
          TITLE: 'Message sent successfully',
        },
        ERRORS: {
          SUBMIT_ERROR: 'Something went wrong. Please try again later.',
          FORM_ERROR: 'Please check the form for errors and try again.',
        },
      },
    },
    FOOTER: {
      CONTACT: 'Contact us',
      CONTACT_MESSAGE: 'Hi! I\'m interested in learning more about wokap. Could you share some details?',
      COPYRIGHT: 'All rights reserved © wokap',
      PRIVACY: 'Privacy Policy',
      LEGAL: 'Legal',
    },
  },
} as const;
